

































import Vue from 'vue';

export default /*#__PURE__*/Vue.extend({
    name: 'glDispopicker', // vue component name
    data(this: any) {
        return {
            business: '5',
            region: 'BZ',
            code: 'C',
            year: this.currentYear,
            number: '',
        };
    },
    props: {
        inputTrip: {
          type: String,
        },
        placeholderYear: {
          type: String,
          default: 'year',
        },
        placeholderTripNumber: {
          type: String,
          default: 'number',
        }
    },
    mounted(this: any) {
        this.setDispoPicker();
    },
    computed: {
        currentYear() {
            return (new Date().getFullYear().toString()).substr(2);
        },
        businessOptions() {
            return ['4', '5', '13', '14', '33', '35', '36', '39'];
        },
        yearsOptions() {
            const start: number = 17;
            const end: number = Number(this.currentYear);
            return [...Array(end + 1).keys()].filter(value => end >= value && start <= value).reverse().map(q => q.toString());
        },
        isValid(this: any) {
            return !(this.number && this.region);
        },
        result(this: any) {
            return [this.business, this.code, this.region, `20${this.year}`, this.number].join('-');
        },
    },
    watch: {
        value(this: any) {
            this.setDispoPicker();
        },
    },
    methods: {
        setDispoPicker(this: any) {
            if (this.inputTrip) {
                const parts = this.inputTrip.split('-');
                [this.business, this.code, this.region, this.year, this.number] = parts;
                this.year = this.year.substr(2);
            } else {
                this.business = '5';
                this.region = 'BZ';
                this.code = 'C';
                this.year = this.currentYear.toString();
                this.number = '';
            }
        },
        sendForm(this: any) {
            this.$emit('selected', this.result);
        },
    },
});
